import React, { useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Dashboard from '../components/dashboard/Dashboard';
import Patients from '../components/medical/Patients';
import Services from '../components/medical/Services';
import Payments from '../components/medical/Payments';
import Doctors from '../components/medical/Doctors';
import Uzd from '../components/medical/Uzd';
import Laboratory from '../components/medical/Laboratory';
import Reports from '../components/medical/Reports';
import Expenses from '../components/medical/Expenses';
import Staff from '../components/medical/Staff';
import Attendance from '../components/medical/Attendance';
import Roles from '../components/medical/Roles';
import Filials from '../components/medical/Filials';
import AnalysisDocumentPage from '../components/medical/AnalysisDocumentPage';
import ReviewControl from '../components/management/ReviewControl';
import TemperamentAnalysis from '../components/management/TemperamentAnalysis';
import CommunicativeAnalysis from '../components/management/CommunicativeAnalysis';
import MotivationAnalysis from '../components/management/MotivationAnalysis';
import AnxietyAnalysis from '../components/management/AnxietyAnalysis';
import NeurastheniaAnalysis from '../components/management/NeurastheniaAnalysis';
import SuicideAnalysis from '../components/management/SuicideAnalysis';
import DepressionAnalysis from '../components/management/DepressionAnalysis';
import KasbAnalysis from '../components/management/KasbAnalysis';
import CustomTestResults from '../components/management/CustomTestResults';
import StudentManagement from '../components/management/StudentManagement';
import PassportManagement from '../components/management/PassportManagement';
import AlertGroupPage from '../components/management/AlertGroupPage';
import Profile from '../components/profile/Profile';
import Settings from '../components/page/Settings';
import TestPeriodSettings from '../components/page/TestPeriodSettings';
import TestBuilderSettings from '../components/page/TestBuilderSettings';
import TestAssignmentSettings from '../components/page/TestAssignmentSettings';
import TestUserSettings from '../components/page/TestUserSettings';
import Notifications from '../components/page/Notifications';
import UnavailableFeature from '../components/page/UnavailableFeature';
import AppContext from '../context/Context';
import { hasPermission } from '../helpers/permissions';
import { unavailableFeatureRoutes } from '../routes';

const PermissionRoute = ({ component: Component, permission, ...rest }) => {
  const { user } = useContext(AppContext);

  return (
    <Route
      {...rest}
      render={props => (hasPermission(user, permission) ? <Component {...props} /> : <Redirect to="/" />)}
    />
  );
};

const DashboardRoutes = () => (
  <Switch>
    <Redirect from="/auth-bridge" exact to="/" />
    <Redirect from="/dashboard" exact to="/" />
    <PermissionRoute path="/" exact component={Dashboard} permission="padmin.dashboard.view" />
    <Route path="/patients" exact component={Patients} />
    <Route path="/services" exact component={Services} />
    <Route path="/payments" exact component={Payments} />
    <Route path="/doctors" exact component={Doctors} />
    <Route path="/uzd" exact component={Uzd} />
    <Route path="/laboratory" exact component={Laboratory} />
    <Route path="/reports" exact component={Reports} />
    <Route path="/expenses" exact component={Expenses} />
    <Route path="/staff" exact component={Staff} />
    <Route path="/roles" exact component={Roles} />
    <Route path="/filials" exact component={Filials} />
    <Route path="/analysis-document" exact component={AnalysisDocumentPage} />
    <Route path="/attendance" exact component={Attendance} />
    <PermissionRoute path="/tekshirish" exact component={ReviewControl} permission="padmin.analytics.view" />
    <PermissionRoute path="/temperament" exact component={TemperamentAnalysis} permission="padmin.analytics.view" />
    <PermissionRoute path="/kommunikativ" exact component={CommunicativeAnalysis} permission="padmin.analytics.view" />
    <PermissionRoute path="/motivatsiya" exact component={MotivationAnalysis} permission="padmin.analytics.view" />
    <PermissionRoute path="/bezovtalanish" exact component={AnxietyAnalysis} permission="padmin.analytics.view" />
    <PermissionRoute path="/nevrasteniya" exact component={NeurastheniaAnalysis} permission="padmin.analytics.view" />
    <PermissionRoute path="/suitsid" exact component={SuicideAnalysis} permission="padmin.analytics.view" />
    <PermissionRoute path="/depressiya" exact component={DepressionAnalysis} permission="padmin.analytics.view" />
    <PermissionRoute path="/kasb-testi" exact component={KasbAnalysis} permission="padmin.analytics.view" />
    <PermissionRoute path="/talabalar" exact component={StudentManagement} permission="padmin.students.view" />
    <PermissionRoute path="/psixologik-pasport" exact component={PassportManagement} permission="padmin.passport.view" />
    <PermissionRoute path="/natijalar" exact component={CustomTestResults} permission="padmin.analytics.view" />
    <PermissionRoute path="/natijalar/:topicKey" exact component={CustomTestResults} permission="padmin.analytics.view" />
    <Redirect from="/xavf-guruhlari" exact to="/xavf-guruhlari/suitsidlar" />
    <PermissionRoute path="/xavf-guruhlari/:slug" exact component={AlertGroupPage} permission="padmin.alerts.view" />
    <Route path="/pages/profile" exact component={Profile} />
    <PermissionRoute path="/test-sozlamalari/test-qoshish" exact component={TestBuilderSettings} permission="padmin.tests.manage" />
    <PermissionRoute path="/test-sozlamalari/biriktirish" exact component={TestAssignmentSettings} permission="padmin.tests.manage" />
    <PermissionRoute path="/test-sozlamalari/davr" exact component={TestPeriodSettings} permission="padmin.tests.manage" />
    <PermissionRoute path="/test-sozlamalari/foydalanuvchilar" exact component={TestUserSettings} permission="padmin.users.manage" />
    <PermissionRoute path="/pages/settings/:section?/:subsection?/:detail?" exact component={Settings} permission="padmin.settings.view" />
    <Route path="/pages/notifications" exact component={Notifications} />
    {unavailableFeatureRoutes.map(route => (
      <Route key={route.to} path={route.to} exact component={UnavailableFeature} />
    ))}
    <Redirect to="/errors/404" />
  </Switch>
);

export default DashboardRoutes;
